export const TYPE_ONE_BUDGET_FOR_ALL = "TYPE_ONE_BUDGET_FOR_ALL"
export const TYPE_ONE_BUDGET_PER_CAMPAIGN = "TYPE_ONE_BUDGET_PER_CAMPAIGN"
export const TYPE_ONE_BUDGET_PER_ADGROUP = "TYPE_ONE_BUDGET_PER_ADGROUP"

export const TYPES = [TYPE_ONE_BUDGET_FOR_ALL, TYPE_ONE_BUDGET_PER_CAMPAIGN, TYPE_ONE_BUDGET_PER_ADGROUP]
export const getTypesData = (t) => ({
   [TYPE_ONE_BUDGET_FOR_ALL]: {
      "Title": t('business_unit_types.global_budget'),
      "Description": t('business_unit_types.global_budget_description'),
      "Short": t('business_unit_types.global_budget_short')
   },
   [TYPE_ONE_BUDGET_PER_CAMPAIGN]: {
      "Title": t('business_unit_types.campaign_budgets'),
      "Description": t('business_unit_types.campaign_budgets_description'),
      "Short": t('business_unit_types.campaign_budgets_short')
   },
   [TYPE_ONE_BUDGET_PER_ADGROUP]: {
      "Title": t('business_unit_types.adgroup_budgets'),
      "Description": t('business_unit_types.adgroup_budgets_description'),
      "Short": t('business_unit_types.adgroup_budgets_short')
   }
});

// Keep the old export for backward compatibility
export const TYPES_DATA = getTypesData;
